import React from "react";
import Box, { BoxProps } from "@mui/material/Box";

export interface PricingFooterProps extends BoxProps {
  noBorder?: boolean;
}

export const PricingFooter = (props: PricingFooterProps) => {
  const showBorder = props.noBorder ? false : true;

  return (
    <Box sx={{ width: "100%" }}>
      <Box style={{ backgroundColor: "#99f2e4" }}>
        {showBorder ? (
          <Box
            style={{
              height: 4,
              border: "5px solid #fff",
              borderRadius: 8,
              backgroundColor: "#fff",
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }}
          ></Box>
        ) : null}
      </Box>
      <Box
        {...props}
        sx={{
          ...props.sx,
          backgroundColor: (theme) => theme.colors.greenLightest,
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};
